import React from 'react';
import Home from './routes/Home.js';
import Callback from './routes/Callback';
import Orders from './routes/Orders';
import Login from './routes/Login';
import Header from './components/Header';
import Footer from './components/Footer';
import { Switch, withRouter } from 'react-router-dom';
import PrivateRoute from './lib/PrivateRoute';
import PublicRoute from './lib/PublicRoute';
import ga from './lib/ga'

type Location = {
  pathname: string
}

const fixedFooterRoutes: string[] = ['/login']

function App({ location }: { location: Location }) {
  ga.usePageViews();
  return (
    <div>
      <Header />
      <Switch>
        {/* Private routes */}
        <PrivateRoute exact path="/" component={Home} />
        {/* Public routes */}
        <PublicRoute exact path="/orders" component={Orders} />
        <PublicRoute exact path="/orders/:orderId" component={Orders} />
        <PublicRoute exact path="/orders/:orderId/station/:stationId" component={Orders} />
        <PublicRoute exact path="/orders/:orderId/station/:stationId/vt/:videoTime" component={Orders} />
        <PublicRoute restricted={true} exact path="/login" component={Login} />
        <PublicRoute restricted={false} exact path="/callback" component={Callback} />
      </Switch>
      <Footer fixedPosition={(!fixedFooterRoutes.indexOf(location.pathname))} />
    </div>
  );
}

export default withRouter(App);
